import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-mentorship-meeting-started",
  templateUrl: "./mentorship-meeting-started.component.html",
})
export class MentorshipMeetingStartedComponent implements OnInit {
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  startDate: any;
  endDate: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  mentorshipMeetingArr: any = []; // Table Data list
  exportMeetingList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = "";

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  totalmentorshipMeetings: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate;
    this.endDate = endDate;
    this.getListing();
    this.meetingsListing();
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "mentorship_meetings_started",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.mentorshipMeetingArr = resp["data"];
            this.totalmentorshipMeetings = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "sl" },
        { data: "meeting_id" },
        { data: "mentee_name" },
        { data: "mentor_name" },
        { data: "meeting_topic" },
        { data: "meeting_duration" },
        { data: "created_at" },
      ],
    };
  }

  meetingsListing() {
    const data = {
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "mentorship_meetings_started",
    };

    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportMeetingList = res["data"];
        this.fieldsToIncludeExcel = [
          "sl",
          "meeting_id",
          "mentee_name",
          "mentor_name",
          "meeting_topic",
          "meeting_duration",
          "created_at",
        ];

        this.exl = true;
        this.loadHide();
      });
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#meeting_started").DataTable();
    table.ajax.reload(null, false);
    this.meetingsListing();
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    const table = $("#meeting_started").DataTable();
    table.ajax.reload(null, false);
    this.meetingsListing();
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportMeetingList,
      this.fieldsToIncludeExcel,
      "Mentorship Successfull Meetings "
    );
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    // Bind to pagination click event
    $("#meeting_started").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // optional for smooth scroll
      });
    });
  }

  ngOnDestroy(): void {
    $("#meeting_started").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
